import React from 'react';
import './login.css';
import icone from '../../assets/mobile/logo.png';
import { setNodeRedBaseURL } from "../../services/axios"

class Login extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      username: '',
      password: '',
    };
  }

  handleChange = (event) => {
    this.setState({ [event.target.id]: event.target.value });
  }

  handleSubmit = (event) => {
    event.preventDefault();
    const user = {
      username: this.state.username,
      password: this.state.password,
    };

    fetch(`${process.env.REACT_APP_NODE_RED_SERVER_OFFLINE_URL}/login`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(user),
    })
    .then(response => response.json())
    .then(data => {
      if (data.success) {
        this.createSession(300 * 60000);
      } else {
        alert("Credenciais inválidas. Tente novamente.");
      }
    })
    .catch((error) => {
      console.error('Erro na conexão:', error);
      alert('Não foi possível conectar ao servidor local. Verifique se o equipamento está ligado e se você está na mesma rede do condomínio.');
    });
  }

  createSession = (duration) => {
    const expirationTime = new Date().getTime() + duration;

    sessionStorage.setItem("loggedIn", "true");
    sessionStorage.setItem("expirationTime", expirationTime.toString());
    
    if (this.state.username === "admin") {
      sessionStorage.setItem("admin", "true");
      sessionStorage.setItem("username", "Administrador");
    } else {
      sessionStorage.setItem("username", "Condominio " + this.state.username);
    }
    sessionStorage.setItem('authMode', 'offline');
    sessionStorage.setItem('nodeRedMode', 'offline');

    setNodeRedBaseURL(process.env.REACT_APP_NODE_RED_SERVER_OFFLINE_URL);
    this.props.navigate('/home'); // Redireciona para /home
  }

  render() {
    return (
      <div className="content-login">
        <div className="login-container">
          <img src={icone} alt="Logo" id="icone" />
          <h2 className='h2-login'>Login</h2>
          <form onSubmit={this.handleSubmit}>
            <input className='input-login' type="text" id="username" placeholder="Nome de usuário" required onChange={this.handleChange} />
            <input className='input-login' type="password" id="password" placeholder="Senha" required onChange={this.handleChange} />
            <button className='button-login' type="submit">Entrar</button>
          </form>
        </div>
      </div>
    );
  }
}

export default Login;